export enum Cooperation {
    SCHARINGER = 'scharinger',
}
